module.exports = __webpack_public_path__ + "img/1569696221.6e54b237.jpg";